var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3.22998C5.5 1.98734 6.50736 0.97998 7.75 0.97998H10.25C11.4926 0.97998 12.5 1.98734 12.5 3.22998V4.99998H15.75C16.9926 4.99998 18 6.00734 18 7.24998V18.25C18 18.6642 17.6642 19 17.25 19H0.75C0.335786 19 0 18.6642 0 18.25V10.25C0 9.00734 1.00736 7.99998 2.25 7.99998H5.5V3.22998ZM7 17.5H11V3.22998C11 2.81577 10.6642 2.47998 10.25 2.47998H7.75C7.33579 2.47998 7 2.81577 7 3.22998V17.5ZM5.5 9.49998H2.25C1.83579 9.49998 1.5 9.83576 1.5 10.25V17.5H5.5V9.49998ZM12.5 17.5H16.5V7.24998C16.5 6.83576 16.1642 6.49998 15.75 6.49998H12.5V17.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.b1bc87779fd92ddbab9c9f495ad73583.svg";
export { ForwardRef as ReactComponent };